module.exports = __webpack_public_path__ + "img/1280.9b21e357.svg";